<template>
  <div id="system-page" v-loading="loading">
    <el-form class="search-pannel row" @submit.native.prevent="doSearch">
      <input type="submit" style="display:none" />
      <div class="col-sm-6">
        <el-input type="text" size="small" v-model="keyword" placeholder="搜索销售人员名称">
          <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
        </el-input>
      </div>
    </el-form>
    <div v-if="users" class="data-list">
      <div v-for="item in users" :key="item.id" class="saler-item-wraper">
        <saler-item :user="item" @privilge-update="privilgeUpdated" />
      </div>
    </div>
    <div v-else class="data-list">
      <div class="saler-item-wraper">
        <div class="saler-item">
          暂无数据
        </div>
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size="pagination.pageSize"
        @current-change="doSearch"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import SalerItem from './SalerItem.vue'
import { loadProxy } from './services'
export default {
  name: 'System',
  components: { SalerItem },
  data () {
    return {
      loading: false,
      keyword: undefined,
      users: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
      }
    }
  },
  computed: {
    allPrivileges () {
      return this.$store.state.plainPermissions.map(t => t.code)
    }
  },
  beforeMount () {
    this.$store.dispatch('loadPermissions')
  },
  mounted () {
    this.doSearch()
  },
  methods: {
    doSearch () {
      const { pageIndex, pageSize } = this.pagination
      const queryModel = { pageIndex, pageSize }
      queryModel.keywords = this.keyword || undefined
      this.loading = true
      loadProxy(queryModel).then(resp => {
        resp.items.forEach(item => {
          if (!item.uiPrivileges.length) {
            item.uiPrivileges = [...this.allPrivileges]
          }
        })
        this.users = resp.items
        const { pageIndex, pageSize, totalCount } = resp
        this.pagination = { pageIndex, pageSize, totalCount }
      }).finally(() => {
        this.loading = false
      })
    },
    privilgeUpdated (newPrivilge) {
      this.user.uiPrivileges = newPrivilge
    }
  }
}
</script>
